import styled from '@emotion/styled';

const Input = styled.input`
  width: 100%;
  border: 1px solid  ;
  margin: 0 auto 10px auto;
  padding: 0.5rem;
  border-radius: 5px;
  font-style: normal;
  margin-top:8px;
  font-weight: 500;
  font-size: 14px;
  line-height: 1rem;
  letter-spacing: -0.3px;
  color: #000;
  height:40px;
  background: rgba(217, 217, 217, 0.4);
  }

`;
const InputArea = styled.textarea`
  width: 100%;
  border: 1px;
  margin: 0 auto 10px auto;
  padding: 0.3rem;
  border-radius: 5px;
  font-style: normal;
  margin-top: 8px;
  font-weight: 500;
  font-size: 14px;
  font-family: Poppins;
  line-height: 1rem;
  letter-spacing: -0.3px;
  border: 1px solid;
  color: #000;
  height: 30%;
  background: rgba(217, 217, 217, 0.4);
  &::placeholder {
    font-family: Poppins;
    font-size: 14px;
    letter-spacing: -0.3px;
    line-height: 1.5rem;
    color: rgba(15, 25, 26, 0.5);
  }
`;

const Form = styled.form``;

export { Form, Input, InputArea };
